import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Trans } from '../../i18n/trans';
import { CheckIcon } from '@common/icons/material/Check';
export function ProductFeatureList({ product }) {
    if (!product.feature_list.length)
        return null;
    return (_jsxs("div", { className: "mt-32 border-t pt-24", children: [_jsx("div", { className: "mb-10 text-sm font-semibold", children: _jsx(Trans, { message: "What's included" }) }), product.feature_list.map(feature => (_jsxs("div", { className: "flex items-center gap-10 py-6 text-sm", children: [_jsx(CheckIcon, { className: "text-primary", size: "sm" }), _jsx(Trans, { message: feature })] }, feature)))] }));
}
